import React from 'react'
import './Breadcrum.css'
import Arrow_icon from '../Assets/breadcrum_arrow.png';
const Breadcrum = ({product}) => {
  return (
    <div className='breadcrum'>
        HOME <img src={Arrow_icon} /> SHOP <img src={Arrow_icon} alt="" /> {product.category} <img src={Arrow_icon} alt="" /> {product.name}
    </div>
  )
}

export default Breadcrum
